export const browserTasks = {
  access: {
    label: 'Workspace access',
    app: 'Workspace admin',
    address: 'workspace.example / people',
    person: 'Alex Chen',
    targetLabel: 'Workspace',
    detailLabel: 'Access level',
    targets: ['Analytics', 'Design', 'Finance'],
    details: ['Viewer', 'Editor'],
    action: 'Grant access',
  },
  equipment: {
    label: 'New-starter laptop',
    app: 'Equipment requests',
    address: 'equipment.example / requests',
    person: 'Jamie Lee',
    targetLabel: 'Laptop',
    detailLabel: 'Delivery',
    targets: ['Standard laptop', 'Developer laptop'],
    details: ['Office collection', 'Home delivery'],
    action: 'Place request',
  },
};

export const serviceDeskTickets = [
  { id: 'IT-1042', title: 'Access for the reporting team', type: 'access', person: 'Alex Chen', target: 'Analytics', detail: 'Editor', message: 'Alex Chen is joining the reporting team this week. Please give them editor access to the Analytics workspace.' },
  { id: 'IT-1043', title: 'Laptop for a new starter', type: 'equipment', person: 'Jamie Lee', target: 'Developer laptop', detail: 'Office collection', message: 'Jamie Lee starts on Monday. Please arrange a developer laptop for them to collect at the office.' },
  { id: 'IT-1044', title: 'Finance review access', type: 'access', person: 'Morgan Liu', target: 'Finance', detail: 'Viewer', message: 'Please give Morgan Liu viewer access to the Finance workspace for this quarter’s review.', requiresSignIn: true },
];

export function actionSignature(type, fields) {
  return JSON.stringify([type, fields.person, fields.target, fields.detail]);
}

// The exhibit uses the same observe, act, and approval boundary throughout.
// Every planned action is derived from the current form and the chosen request.
export function nextBrowserAction(task, form, state) {
  if (state.submitted) return { kind: 'complete' };
  if (!state.signedIn) return { kind: 'sign-in' };
  if (!state.opened) return { kind: 'open' };
  for (const field of ['person', 'target', 'detail']) {
    if (form[field] !== task[field]) return { kind: 'fill', field, value: task[field] };
  }
  if (state.approvedSignature !== actionSignature(task.type, form)) return { kind: 'approval' };
  return { kind: 'submit' };
}
